const validate = require("./validators");
const ms_applicant = require("./validators/ms_applicant");
const ms_applicant_referee = require("./validators/ms_applicant_referee");
const ms_applicant_sitting = require("./validators/ms_applicant_sitting");
const ms_applicant_result = require("./validators/ms_applicant_result");
const ms_applicant_alevel = require("./validators/ms_applicant_alevel");
const ms_delete = require("./validators/ms_delete");
const ms_application_fee = require("./validators/ms_application_fee");
const ms_application_uploads = require("./validators/ms_application_uploads");
const ms_applications = require("./validators/ms_applications");
const ms_college = require("./validators/ms_college");
const ms_department = require("./validators/ms_department");
const ms_programme = require("./validators/ms_programme");
const ms_application_fee_rrr = require("./validators/ms_application_fee_rrr");
const ms_session = require("./validators/ms_session");
const ms_course = require("./validators/ms_course");
const ms_notification = require("./validators/ms_notification");
const ms_general = require("./validators/ms_general");
const ms_set_registration = require("./validators/ms_set_registration");
const ms_page_group = require("./validators/ms_page_group");
const ms_sub_page_group = require("./validators/ms_sub_page_group");
const ms_pages = require("./validators/ms_pages");
const ms_user_groups = require("./validators/ms_user_groups");
const ms_user_permissions = require("./validators/ms_user_permissions");
const ms_group_members = require("./validators/ms_group_members");
const ms_group_permissions = require("./validators/ms_group_permissions");
const ms_programme_application_fee_items = require("./validators/ms_programme_application_fee_items");
const ms_programme_admission_requirement = require("./validators/ms_programme_admission_requirement");
const ms_result_profile = require("./validators/ms_result_profile");
const ms_tuition_fee_items = require("./validators/ms_tuition_fee_items");
const ms_programme_tuition_fee_items = require("./validators/ms_programme_tuition_fee_items");
const ms_course_allocation = require("./validators/ms_course_allocation");
const ms_staff = require("./validators/ms_staff");
const ms_course_topic = require("./validators/ms_course_topic");
const ms_course_material = require("./validators/ms_course_material");
const ms_course_contact = require("./validators/ms_course_contact");
const ms_student_widthdraws = require("./validators/ms_student_widthdraws");
const ms_students = require("./validators/ms_students");
const ms_schedule_of_fee_items = require("./validators/ms_schedule_of_fee_items");
const ms_generated_rrr = require("./validators/ms_generated_rrr");
const ms_student_progression = require("./validators/ms_student_progression");


module.exports = {
  validate,
  ms_staff,
  ms_applicant,
  ms_notification,
  ms_course_allocation,
  ms_applicant_referee,
  ms_applicant_sitting,
  ms_programme_tuition_fee_items,
  ms_applicant_result,
  ms_applicant_alevel,
  ms_delete,
  ms_result_profile,
  ms_application_fee,
  ms_application_uploads,
  ms_applications,
  ms_application_fee_rrr,
  ms_college,
  ms_department,
  ms_programme,
  ms_session,
  ms_general,
  ms_course,
  ms_set_registration,
  ms_page_group,
  ms_sub_page_group,
  ms_pages,
  ms_user_groups,
  ms_user_permissions,
  ms_group_members,
  ms_group_permissions,
  ms_programme_application_fee_items,
  ms_programme_admission_requirement,
  ms_tuition_fee_items,
  ms_course_topic,
  ms_course_material,
  ms_course_contact,
  ms_student_widthdraws,
  ms_students,
  ms_schedule_of_fee_items,
  ms_generated_rrr,
  ms_student_progression,
};
